export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function api(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    credentials: "include",
    ...options,
    headers: { "Content-Type": "application/json", ...(options.headers || {}) }
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new Error(formatDetail(data.detail) || `Request failed (${res.status})`);
  return data;
}

export function formatDetail(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => (e && typeof e.msg === "string" ? e.msg.replace(/^Value error, /, "") : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const ADMIN_ROLES = ["super_admin", "association_admin", "content_manager", "event_manager"];
export const isAdmin = user => !!user && ADMIN_ROLES.includes(user.role);
export const money = (amount, currency = "INR") => new Intl.NumberFormat("en-IN", { style: "currency", currency, maximumFractionDigits: 0 }).format(amount || 0);

export const defaultSettings = {
  association_name: "Diploma Civil Engineers Association",
  short_name: "DCEA",
  email: "office@dceahd.org",
  phone: "+91 836 244 1188",
  address: "Hubli–Dharwad, Karnataka",
  office_hours: "Mon–Sat · 10:00–17:00",
  tagline: "Connect • Contribute • Build • Grow",
  footer_text: "A professional home for diploma civil engineers.",
  copyright: "© 2026 DCEA Hubli–Dharwad"
};

export const navItems = [
  ["About DCEA", "/about"], ["Leadership", "/leadership"], ["Members", "/members"],
  ["Events", "/events"], ["News & Notices", "/news"], ["Gallery", "/gallery"],
  ["Videos", "/videos"], ["Sponsors", "/sponsors"], ["Downloads", "/downloads"], ["Contact", "/contact"]
];

export const formatDate = d =>
  new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });

export const isUrl = v => typeof v === "string" && (/^https?:\/\//.test(v) || v.startsWith("/api/files/"));
export const mediaUrl = v => (v && v.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${v}` : v);

export async function uploadMedia(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${API}/admin/media/upload`, { method: "POST", body: fd, credentials: "include" });
  const data = await res.json();
  if (!res.ok) throw new Error(data.detail || "Upload failed");
  return data;
}
